import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { AnimatePresence, motion } from 'framer-motion';

interface FollowedDialogProps {
  isAlertOpen: boolean;
  setIsAlertOpen: (isAlertOpen: boolean) => void;
}

const FollowedDialog = ({ isAlertOpen, setIsAlertOpen }: FollowedDialogProps) => {
  const { t } = useTranslation();

  useEffect(() => {
    const timeout = setTimeout(() => {
      setIsAlertOpen(false);
    }, 2000);
    return () => clearTimeout(timeout);
  }, [setIsAlertOpen]);

  return (
    <AnimatePresence>
      {isAlertOpen && (
        <motion.div
          onClick={() => {
            setIsAlertOpen(false);
          }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="absolute top-0 left-0 right-0 bottom-0 bg-black/60 flex items-center justify-center z-[1000]"
        >
          <motion.div
            onClick={(e) => e.stopPropagation()}
            initial={{ y: -50, scale: 0.95 }}
            animate={{ y: 0, scale: 1 }}
            exit={{ y: 50, opacity: 0 }}
            transition={{ type: 'spring', stiffness: 300, damping: 20 }}
            className="flex flex-col"
          >
            <img
              src="/assets/icons/fan-buddy/WavingHand.png"
              alt="Waving Hand"
              className="w-[180px] h-[180px]"
            />
            <p className="text-[26px] font-extrabold text-pure-white text-center leading-[31px] mb-[10px]">
              {t('FollowedDialog.title')}
            </p>
            <p className="text-[15px] leading-[18px] text-pure-white text-center whitespace-pre-line mb-[7px]">
              {t('FollowedDialog.description')}
            </p>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default FollowedDialog;
